import {
  AppBar,
  Card,
  CardContent,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { Column, Columns, Stack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { Form, FormikProvider } from 'formik';
import { useAppFormik } from 'shared/form/AppFormik';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import styled from 'styled-components';
import {
  useLoadOfferNotificationSettings,
  useSettingsAPI,
} from '../../settings/data/SettingsAPI';
import { loadOfferNotificationSettingsPayloadSchema } from '../../settings/data/SettingsDTO';
import { SettingsSMSAndEmailNotificationsCarrier } from '../../settings/SettingsSMSAndEmailNotifications';

const ActionBar = styled(AppBar)`
  bottom: 0;
  top: auto;
`;

export function NotificationsPage() {
  const { updateLoadOfferNotificationSettings } = useSettingsAPI();
  const { data: loadOfferNotification } = useLoadOfferNotificationSettings();

  const formik = useAppFormik({
    initialValues: loadOfferNotification,
    validationSchema: loadOfferNotificationSettingsPayloadSchema,
    onSubmit(values) {
      return updateLoadOfferNotificationSettings(values);
    },
    getSuccessMessage() {
      return 'Notification Settings successfully updated';
    },
  });

  useDocumentTitle('Load Offer Notifications');

  return (
    <WebviewLayout>
      <FormikProvider value={formik}>
        <Form>
          <Box padding="xsmall">
            <Card aria-label="Load Offer Settings Card">
              <CardContent>
                <Stack space="xsmall">
                  <Typography variant="h3">
                    SMS and Email Notifications
                  </Typography>
                  <Stack space="medium">
                    <SettingsSMSAndEmailNotificationsCarrier
                      loadOfferNotification={loadOfferNotification}
                    />
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          </Box>

          <ActionBar position="fixed">
            <Toolbar>
              <Columns space="small">
                <Column>
                  <Button
                    variant="neutral"
                    fullWidth={true}
                    disabled={formik.isSubmitting || !formik.dirty}
                    onClick={() => {
                      formik.resetForm();
                    }}
                  >
                    Reset
                  </Button>
                </Column>

                <Column>
                  <Button
                    type="submit"
                    fullWidth={true}
                    pending={formik.isSubmitting}
                    disabled={formik.isSubmitting || !formik.dirty}
                  >
                    Save
                  </Button>
                </Column>
              </Columns>
            </Toolbar>
          </ActionBar>
        </Form>
      </FormikProvider>
    </WebviewLayout>
  );
}
